import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import file from "../assets/svg/downFile.svg";
import SubmitForm from '../components/contact/SubmitForm';
import styled from 'styled-components';
import AppLayout from '../components/AppLayout';

const Contact = () => {
  const [isLinkHovered, setIsLinkHovered] = useState(false);
  const location = useLocation();
  const [actionClass, setActionClass] = useState('');

  const handleLinkMouseOver = () => {
    setIsLinkHovered(true);
  };

  const handleLinkMouseLeave = () => {
    setIsLinkHovered(false);
  };
  useEffect(() => {
    setActionClass('active');
  }, [location.pathname]);
  return (
    <HelmetProvider>
      <AppLayout>
        <Helmet>
          <title>TOPPING - Contact Us</title>
          <meta name="description" content="토핑과 함께 당신의 아이디어를 실현해보세요. 웹/앱/플랫폼 서비스 개발 전문 회사 토핑에 문의하세요." />
          <meta name="keywords" content="TOPPING, 토핑, 웹개발, 앱개발, 플랫폼개발, IT컨설팅" />
          <meta property="og:title" content="TOPPING - Contact Us" />
          <meta property="og:description" content="토핑과 함께 당신의 아이디어를 실현해보세요. 웹/앱/플랫폼 서비스 개발 전문 회사 토핑에 문의하세요." />
          <meta property="og:type" content="website" />
        </Helmet>
        <ContactWrap className={`inner section ${actionClass}`}>
          <div className='contactBox action1'>
            <h2 className='introTitle'>
              토핑과 함께<br />
              당신의 아이디어를<br />
              실현해보세요.
            </h2>
            <a
              href="/assets/file/topping_사업소개서.pdf"
              onMouseOver={handleLinkMouseOver}
              onMouseLeave={handleLinkMouseLeave}
              download
              className={isLinkHovered ? 'hovered-link' : ''}>
              <span>회사소개서 다운로드</span>
              <img src={file} />
            </a>
          </div>
          <p onMouseOver={handleLinkMouseOver}
            onMouseLeave={handleLinkMouseLeave}
            className={isLinkHovered ? 'introText address hovered-link' : 'introText address action1'}>
            서울 특별시 금천구 가산디지털로 121.<br />
            에이스 가산타워 1304호
          </p>
          <p onMouseOver={handleLinkMouseOver}
            onMouseLeave={handleLinkMouseLeave}
            className={isLinkHovered ? 'introText hovered-link' : 'introText action1'}>
            info@topping.io
          </p>
          <SubmitForm />
        </ContactWrap>
      </AppLayout>
    </HelmetProvider>
  );
};

const ContactWrap = styled.div`
  .contactBox{
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding-top:240px;
    a{
      padding:20px 40px; 
      border-radius: 10px;
      display: flex;
      background-color: #fff;
      color:#000;
      align-items: center;
      span{
        margin-right:15px;
        font-weight: 600;
        font-size: 20px;
      }
    }
  }
  .introTitle{
    text-align: left;
  }
  .introText{
    line-height: 36px;
    display: table;
    text-align: left;
    &.address{
      padding:30px 0 
    }
  }
`;

export default Contact;